import { render, staticRenderFns } from "./evaluate_shopList.vue?vue&type=template&id=af981c5a&scoped=true"
import script from "./evaluate_shopList.vue?vue&type=script&lang=js"
export * from "./evaluate_shopList.vue?vue&type=script&lang=js"
import style0 from "./evaluate_shopList.vue?vue&type=style&index=0&id=af981c5a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af981c5a",
  null
  
)

export default component.exports